import { editIssue } from './issues/editIssue'
import { editHeroImage, uploadFiles } from './issues/editHeroImage'
import { getIssueList } from './issues/getIssueList'
import { editCompany } from './companies/editCompany'
import { getBusinessCategoriesList } from './businessCategories/getBusinessCategoriesList'
import { getCompanyList } from './companies/getCompanyList'
import { getIssueDetails } from '~/plugins/api/issues/getIssueDetails'
import { sendIssueEmail } from '~/plugins/api/issues/sendEmail'
import { sendCompanyEmail } from '~/plugins/api/companies/sendEmail'
import { getCompanyDetails } from '~/plugins/api/companies/getCompanyDetails'

type Api = {
  issues: {
    editIssue: typeof editIssue
    getIssueDetails: typeof getIssueDetails
    sendIssueEmail: typeof sendIssueEmail
    getIssueList: typeof getIssueList
    editHeroImage: typeof editHeroImage
    uploadFiles: typeof uploadFiles
  }
  companies: {
    getCompanyDetails: typeof getCompanyDetails
    editCompany: typeof editCompany
    getBusinessCategoriesList: typeof getBusinessCategoriesList
    getCompanyList: typeof getCompanyList
    sendCompanyEmail: typeof sendCompanyEmail
  }
}

declare module '#app' {
  type NuxtApp = {
    $api: Api
  }
}

declare module 'vue' {
  type ComponentCustomProperties = {
    $api: Api
  }
}

export default defineNuxtPlugin(() => {
  return {
    provide: {
      api: {
        issues: {
          getIssueDetails,
          editIssue,
          sendIssueEmail,
          getIssueList,
          editHeroImage,
          uploadFiles,
        },
        companies: {
          sendCompanyEmail,
          getCompanyDetails,
          editCompany,
          getBusinessCategoriesList,
          getCompanyList,
        },
      } satisfies Api,
    },
  }
})
